import PropTypes from 'prop-types'
import Imagen from '../imagen/Imagen'
import Precios from '../reutilizables/precios/Precios'
import styles from './Vendedor.module.css'

const COLUMNAS_TITULO_SIN_IMAGEN = 5
const COLUMNAS_TITULO_CON_IMAGEN = 4
const COLUMNAS_PRECIO_CON_IMAGEN = 5
const COLUMNAS_PRECIO_SIN_IMAGEN = 6

export const DetallePrecio = ({
  titulo,
  vendedor,
  valorUnitarioSinIva,
  esMayorista,
  costoEnvio = 0,
  usaImagen = false
}) => {
  return (
    <>
      <h3>{titulo}</h3>
      <div className="col-12 ">
        <div className="row no-gutters align-items-center">
          {usaImagen && <div className="col-2"></div>}

          <h5
            className={`col-${
              usaImagen ? COLUMNAS_TITULO_CON_IMAGEN : COLUMNAS_TITULO_SIN_IMAGEN
            }`}
          >
            Item
          </h5>
          <h5 className="col-1 text-center">Cantidad</h5>
          <h5
            className={`col-${
              usaImagen ? COLUMNAS_PRECIO_CON_IMAGEN : COLUMNAS_PRECIO_SIN_IMAGEN
            } text-center`}
          >
            Precio
          </h5>
        </div>
      </div>
      {vendedor.pedidoItems.map((item) => (
        <div className="col-12 mt-4" key={item.idPublicacion}>
          <div className="row no-gutters align-items-center">
            {usaImagen && (
              <div className="col-2 text-right">
                <div
                  className="cont-perfil-img"
                  style={{ position: 'relative', top: '1%' }}
                >
                  <Imagen idPublicacion={item.idPublicacion} width="60" />
                </div>
              </div>
            )}
            <div
              className={`col-${
                usaImagen ? COLUMNAS_TITULO_CON_IMAGEN : COLUMNAS_TITULO_SIN_IMAGEN
              } text-left`}
            >
              {item.titulo}
            </div>
            <div className="col-1 text-center">{item.cantidad}</div>
            <div
              className={`col-${
                usaImagen ? COLUMNAS_PRECIO_CON_IMAGEN : COLUMNAS_PRECIO_SIN_IMAGEN
              }`}
            >
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Precios
                  precio={valorUnitarioSinIva(item)}
                  monedaSimbolo={item.monedaSimbolo}
                  alicuota={item.alicuota}
                  cantidad={1}
                  showSinIVA={true}
                  sufijo={esMayorista(item) ? '(mayorista)' : ''}
                  className={styles['vendedor__precios-item']}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
      {costoEnvio > 0 && (
        <div className="col-12 mt-4">
          <div className="row no-gutters align-items-center">
            {usaImagen && <div className="col-2"></div>}
            <div
              className={`col-${
                usaImagen ? COLUMNAS_TITULO_CON_IMAGEN : COLUMNAS_TITULO_SIN_IMAGEN
              } text-left`}
            >
              <h6>
                <strong>Costo de Envío</strong>
              </h6>
            </div>
            <div className="col-1"></div>
            <div
              className={`col-${
                usaImagen ? COLUMNAS_PRECIO_CON_IMAGEN : COLUMNAS_PRECIO_SIN_IMAGEN
              }`}
            >
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Precios
                  nombre="Envío"
                  precio={costoEnvio}
                  monedaSimbolo={'$'}
                  alicuota={21}
                  showSinIVA={true}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="col-12 mt-4">
        <div className="row no-gutters align-items-center">
          {usaImagen && <div className="col-2"></div>}
          <div
            className={`col-${
              usaImagen ? COLUMNAS_TITULO_CON_IMAGEN : COLUMNAS_TITULO_SIN_IMAGEN
            } text-left`}
          >
            <h5>
              <strong>Total</strong>
            </h5>
          </div>
          <div className="col-1"></div>
          <div
            className={`col-${
              usaImagen ? COLUMNAS_PRECIO_CON_IMAGEN : COLUMNAS_PRECIO_SIN_IMAGEN
            }`}
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Precios
                items={vendedor.pedidoItems}
                showSinIVA={true}
                monedaSimbolo={'$'}
                costoEnvio={costoEnvio}
                className={styles['vendedor__precios-destacado']}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

DetallePrecio.propTypes = {
  titulo: PropTypes.string,
  vendedor: PropTypes.shape({
    idVendedor: PropTypes.number.isRequired,
    razonSocial: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacion: PropTypes.number.isRequired,
        titulo: PropTypes.string,
        nombre: PropTypes.string,
        cantidad: PropTypes.number,
        cantidadMayorista: PropTypes.number,
        precioUnitario: PropTypes.number,
        precioUnitarioMayorista: PropTypes.number,
        alicuota: PropTypes.number,
        monedaSimbolo: PropTypes.string
      })
    ).isRequired
  }).isRequired,
  valorUnitarioSinIva: PropTypes.func.isRequired,
  esMayorista: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  costoEnvio: PropTypes.number,
  totalConEnvio: PropTypes.number,
  usaImagen: PropTypes.bool.isRequired
}
